import { Star, User } from "lucide-react";

export default function TestimonialsSection() {
    const testimonials = [
        {
            id: 1,
            text: "Bold Edge did a fantastic job capturing reels for our brand. The creativity and quality were outstanding, our reels got incredible views and sparked a great response from our customers. It truly made a difference in our online presence.",
            author: "Pushpank Kaushik",
            title: "Jassper Shipping",
            services: ["Digital Marketing", "Social Media Handling", "Website design and development"],
            rating: 5,
            image_url: '/testimonials/testimonial-jassper.jpg'

        },
        {
            id: 2,
            text: "Working with Bold Edge was a game-changer — we saw a 3x boost in engagement within the first month after launch.",
            author: "Ashwini Kumar",
            title: "Oesten Spaces",
            services: ["Digital Marketing", "Social Media Handling"],
            rating: 5,
            image_url: '/testimonials/testimonial-oesten.jpg'

        },
        {
            id: 3,
            text: "Loved the reels Bold Edge created for us! They were so engaging and well-shot that we received an amazing number of views and fantastic feedback from our customers. Totally worth it!",
            author: "Eshwar Reddy",
            title: "Charminar Indian Restaurant",
            services: ["Social Media Posts"],
            rating: 5,
            image_url: '/testimonials/testimonial-charminar.jpg'
        }
    ];

    const renderStars = (rating) => {
        return Array.from({ length: rating }, (_, index) => (
            <Star key={index} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
        ));
    };

    const highlightKeyPhrases = (text) => {
        const phrases = [
            "made a difference",
            "engaging and well-shot",
            "3x boost",
            "elevates your online presence"
        ];

        let highlightedText = text;
        phrases.forEach(phrase => {
            if (text.includes(phrase)) {
                highlightedText = highlightedText.replace(
                    phrase,
                    `<span class="bg-brand-orange/40 px-1 rounded">${phrase}</span>`
                );
            }
        });

        return highlightedText;
    };

    return (
        <section className="">
            <div className="max-w-7xl mx-auto">
                <h1 className='text-3xl md:text-6xl md:text-center font-bold'>What Our <span className='text-brand-orange'>Happy Clients Say</span> </h1>
                <p className="md:text-center mt-6">Join hundreds of brands that trust Bold Edge to deliver creativity, clarity, and results.</p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-8 mt-12">
                    {testimonials.map((testimonial) => (
                        <div
                            key={testimonial.id}
                            className="flex flex-col justify-between backdrop-blur-2xl border border-brand-orange/30 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
                        >
                            <div>
                                <div className="flex mb-4">
                                    {renderStars(testimonial.rating)}
                                </div>

                                <div className="mb-4">
                                    <p
                                        className="text-white leading-relaxed"
                                        dangerouslySetInnerHTML={{
                                            __html: `"${highlightKeyPhrases(testimonial.text)}"`
                                        }}
                                    />
                                </div>

                                {testimonial.services && testimonial.services.length > 0 && (
                                    <div className="flex flex-wrap gap-2 mb-6">
                                        {testimonial.services.map((service, idx) => (
                                            <span
                                                key={idx}
                                                className="bg-[#5f2e09] text-[#f0f0f0] text-xs font-medium px-3 py-1 rounded-full"
                                            >
                                                {service}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="flex items-center">
                                <div className="w-12 h-12 border border-[#505050] rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                                    <img
                                        className="rounded-full block "
                                        src={testimonial.image_url}
                                    />
                                </div>
                                <div>
                                    <p className="font-semibold text-white text-sm">
                                        {testimonial.author}
                                    </p>
                                    <p className="text-[#d0d0d0] text-sm">
                                        {testimonial.title}
                                    </p>
                                </div>
                            </div>
                        </div>

                    ))}
                </div>
            </div>
        </section>
    );
}
